import { Box, Container, Flex, Heading, Image, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CtaButton } from '../components/CtaButton';

export function Confidence() {
  const { t } = useTranslation();
  return (
    <Box
      as="section"
      id="confidence"
      position="relative"
      overflow="hidden"
      bgGradient="linear(135deg, #fffaf9 18%, #fbe5d8 88%)"
    >
      <Container maxW="1240px" py={{ base: 16, lg: 20 }}>
        <Flex direction={{ base: 'column', lg: 'row' }} align="flex-start" gap={{ base: 10, lg: 8 }}>
          <Stack flex="1.1" spacing="20px" maxW={{ lg: '600px' }}>
            <Flex align="center" gap="10px">
              <Image src="/images/landing/why-wave.png" alt="" h="28px" opacity={0.5} sx={{ filter: 'blur(0.4px)' }} draggable={false} />
              <Text fontSize="sm" fontWeight={600} letterSpacing="0.14em" color="#CCBABD">
                {t('landing.confidence.label')}
              </Text>
              <Image src="/images/landing/why-wave.png" alt="" h="28px" opacity={0.5} sx={{ filter: 'blur(0.4px)', transform: 'scaleX(-1)' }} draggable={false} />
            </Flex>
            <Heading
              as="h2"
              fontFamily="heading"
              fontWeight={700}
              fontSize="display.lg"
              lineHeight={1.12}
              letterSpacing="-0.01em"
              color="onboarding.deepPlum"
            >
              {t('landing.confidence.title')}
            </Heading>
            <Text fontSize="xl" fontWeight={600} color="onboarding.roseDeep">
              {t('landing.confidence.subtitle')}
            </Text>
            <Text fontSize="md" color="onboarding.roseMid" lineHeight={1.6}>
              {t('landing.confidence.body1')}
            </Text>
            <Text fontSize="md" color="onboarding.roseMid" lineHeight={1.6}>
              {t('landing.confidence.body2')}
            </Text>
            <Box pt="8px">
              <CtaButton
                to="/onboarding"
                bg="onboarding.plum"
                color="white"
                borderRadius="pill"
                height="48px"
                px="28px"
                fontSize="md"
                fontWeight={600}
                _hover={{ bg: 'onboarding.roseDeep' }}
                withArrow
                trackEventName="cta_click"
                trackProps={{ section: 'confidence' }}
              >
                {t('landing.confidence.cta')}
              </CtaButton>
            </Box>
          </Stack>

          <Flex flex="0.9" justify={{ base: 'center', lg: 'flex-end' }} align="flex-start" w="full" mb={{ lg: '-200px' }}>
            <Image
              src="/images/landing/confidence-phone.png"
              alt=""
              w={{ base: '280px', md: '340px', lg: '420px' }}
              draggable={false}
            />
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
}
